import { parsePhoneNumberFromString } from "libphonenumber-js";

export const GROUP_CLASS_SLUG = "local-group-singing-classes";

export function validateGroupClassInterest(payload: unknown) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return { error: "Please check your details and try again." } as const;
  }
  const body = payload as Record<string, unknown>;
  const text = (key: string) => typeof body[key] === "string" ? (body[key] as string).trim() : "";
  const name = text("name");
  const email = text("email").toLowerCase();
  const phone = parsePhoneNumberFromString(text("phone"), "GB");
  const note = text("note");
  if (!name || name.length > 120) return { error: "Please add your name (up to 120 characters)." } as const;
  if (email.length > 254 || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return { error: "Please add a valid email address." } as const;
  if (!phone?.isValid()) return { error: "Please add a valid telephone number, including the country code for numbers outside the UK." } as const;
  if (note.length > 2000) return { error: "Please keep your note under 2,000 characters." } as const;
  if (body.consent !== true) return { error: "Please confirm we can contact you about group singing classes." } as const;
  return { value: {
    email, name, language: "en", item_type: "course", item_id: GROUP_CLASS_SLUG,
    course_slug: GROUP_CLASS_SLUG, course_title: "Local group singing classes",
    source_path: body.sourcePath === "/group-singing-classes" ? "/group-singing-classes" : "/",
    notes: `Telephone: ${phone.number}\nContact permission: group class availability and details only.${note ? `\nOptional note: ${note}` : ""}`,
    status: "active", email_opt_in: true,
  } } as const;
}
